import React from 'react'
import PropTypes from 'prop-types'
import SearchIcon from 'components/material-symbol/icons/Search'
import RouterLinkButton from 'components/router-link-button'
import SectionEmptyState from 'components/section-empty-state'
import LoadError from './load-error'
import { REQUESTS_PATH } from './utils'

export const RequestNotFound = () => (
  <SectionEmptyState
    Icon={SearchIcon}
    title="We couldn't find that Virtual Coaching request"
    caption="The link may be out of date, or it belongs to a different account. Sign in with the account you used to buy it."
    action={
      <RouterLinkButton variant="contained" color="primary" to={REQUESTS_PATH}>
        View my Virtual Coaching
      </RouterLinkButton>
    }
  />
)

export const RequestLoadError = ({ error, onRetry }) => (
  <LoadError
    error={error}
    title="We couldn't load your Virtual Coaching request"
    onRetry={onRetry}
  />
)

RequestLoadError.propTypes = {
  error: PropTypes.object,
  onRetry: PropTypes.func,
}
